<template>
    <div class="edit-user">

            <div class="card">
                <div class="card-header">
                    <h5 class="card-title text-center" v-if="user && !user.AppUserId">Add User</h5>
                    <h5 class="card-title text-center" v-if="user && user.AppUserId">Edit User</h5>
                    <hr>
                </div>
                <div class="card-body">
                    <div class="row mb-2">
                        <BasicTextInput label="First Name"
                                        v-model="user.FirstName"
                                        :validator="$v.user.FirstName"
                                        :validatorMsgMap="validatorMsgMapBase"
                                        class="col-6" />
                        <BasicTextInput label="Last Name"
                                        v-model="user.LastName"
                                        :validator="$v.user.LastName"
                                        :validatorMsgMap="validatorMsgMapBase"
                                        class="col-6" />
                    </div>

                    <div class="row mb-2">
                        <!-- <PhoneNumberInput label="Phone" class="col-6" v-model="user.MobilePhone" /> -->
												<BasicTextInput   label="Email / Logon"
																					name="notASearchField"
																					class="col-6"
																					type="search"
																					autocomplete="off"
																					:validator="$v.user.Email"
																					:validatorMsgMap="validatorMsgMapBase"
																					@input="updateEmailToLowerCase"
																					v-model="user.Email"       />

												<div class="col-6" v-if="can('access-user-lockout')">
													<div class="d-flex justify-content-center  align-items-center">
															<div class="user-locked-state">Logon: <span :class="lockoutStatusClass">{{ lockoutStatus }}</span></div>
															<ToggleSwitch v-model="user.IsLockedOut" @change="lockedOutChanged" class="user-locked-state-toggle"/>
													</div>
                        </div>


                    </div>

                    <!-- <div class="row mb-2">
                        <BasicTextInput label="Address" class="col-8" v-model="user.AddressLine1" />
                        <BasicTextInput label="Suite"   class="col-4" v-model="user.AddressLine2" />
                    </div>

                    <div class="row mb-2">
                        <BasicTextInput label="City"         class="col-4"  v-model="user.City"/>
                        <StateSelect    label="Select State" class="col-4"  v-model="user.StateProvinceId" />
                        <ZipCodeInput   label="Zip Code"     class="col-4"  v-model="user.ZipCode" />
                    </div> -->

                    <div class="row mb-2">
                        <RoleSelect    v-model.number="user.UserRoleId"
                                       :disabled="userPersisted"
                                       :roles="roles"
                                       class="col-6" label="Role" />
                        <ManagerSelect v-model="user.ManagerId"
                                       class="col-6"
                                       label="Manager"
                                       :disabled="selectedUserIsNotSalesRep"
                                       v-if="hasManagerSelectAuthority"
                                       :potentialManagers="potentialManagers"/>
                    </div>

                    <div class="row mb-2">
                        <div class="col-6">
                            <label><b>Groups</b></label>
                            <div class="form-group">
                                <v-select label="Name"
                                          v-model="user.GroupIds"
                                          multiple
                                          :disabled="user.CanAccessAllGroups"
                                          :options="groupOptions" :reduce="group => group.Id"
                                          class="group-select" />
                            </div>
                        </div>
												<UserTypeSelect v-model.number="user.UserType"
													:usertypes="usertypes"
													class="col-6" label="User Type" />

										</div>

										<div class="row mb-2">
													<div class="col-6">
                            <Checkbox label="All Groups" :value="user.CanAccessAllGroups" @input="onChargeableChange('CanAccessAllGroups', $event)" />
                        </div>
												<div class="col-6">
                            <Checkbox label="Is Visible To All Reps"  v-model="user.IsVisibleToAllReps" />
                        </div>
										</div>

										<div class="row mb-2">
												<div class="col-6">
                            <Checkbox label="Can View All Orders" :value="user.CanViewAllOrders" @input="onChargeableChange('CanViewAllOrders', $event)" />
                        </div>
												<div class="col-6">
                            <Checkbox label="Limited/Transfer User" v-model="user.IsLimitedTransferUser" />
                        </div>
										</div>

										<div class="row mb-2">
                        <div class="col-6">
                            <Checkbox label="Can Upload Configurators" v-model="user.CanUploadConfigurators" />
                        </div>
                    </div>

                    <div class="row mb-2">
                        <div class="col-6">
                            <div class="d-flex justify-content-center  align-items-center">
                                <button class="btn btn-secondary btn-block" v-if="userId && !user.EmailConfirmed" @click="resendEmail">Resend Activation Email</button>
                            </div>
                        </div>
                    </div>

                    <div class="mt-4">
                        <button class="btn btn-primary btn-block" v-if="user && !user.AppUserId" @click="createUser">Create User</button>
                        <button class="btn btn-primary btn-block" v-if="user && user.AppUserId"  @click="updateUser">Update User</button>
                    </div>
                </div>
            </div>

        <Modal ref="chargeModal" :disable_background_click_to_close="true" wrapper_classes="position-absolute">
            <div class="p-4 text-center" style="max-width:420px">
                <p class="mb-4">If saved, the changes you have made will result in increased charges for this user</p>
                <div class="d-flex justify-content-center">
                    <button class="btn btn-secondary mr-3" @click="onChargeDialogCancel">Cancel</button>
                    <button class="btn btn-primary"         @click="onChargeDialogAccept">Accept</button>
                </div>
            </div>
        </Modal>
    </div>
</template>

<script>
    import { UserService, DealerService }         from '@/services';
    import { mapState }            from 'vuex';
    import { validatorMsgMapBase } from "@/modules/helpers";
    import {
        required,
        email,
    }                              from 'vuelidate/lib/validators';
    import {
        userRoleEnum,
        getKeyByValue
    }                              from "../../../modules/helpers";

    export default {
        name: "DealerUsersEdit",
        data: () => {
            return {
                validatorMsgMapBase: validatorMsgMapBase,
                user: {
									FirstName: '',
									LastName:  '',
									MobilePhone: '',
									Email: '',
									EmailToLowerCase: '',
									AddressLine1 : '',
									AddressLine2 :  '',
									City: '',
									StateProvinceId : null,
									ZipCode : null,
									UserRoleId: -1,
									ManagerId: null,
									GroupIds: [],
									IsLockedOut: false,
									CanUploadConfigurators: false,
									UserType: 0,
                },
                chargePendingField: null,
            }
        },
        props: {
            userId: {
                type: Number,
                default: null,
            },
            users: {
               type: Array,
            },
            groups: {
               type: Array,
            }
        },
        computed: {
            ...mapState(['currentUser']),
            updateEmailToLowerCase(){
                this.user.EmailToLowerCase = this.user.Email.toLowerCase();
            },
            potentialManagers(){
                // only sales reps will have managers, and only Sales Manager will be their managers, so just return a list of sales managers...
                return this.users.filter(du => du.UserRoleId === 3); // 3 === 'Sales Manager'
            },
            selectedUserIsNotSalesRep(){
                return this.user.UserRoleId !== 4;
            },
            userPersisted(){
                return !!this.user.AppUserId;
            },
            hasManagerSelectAuthority(){
                let role = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);
                if ( role === 'SmartSales Admin'   ) return true;
                if ( role === 'Sales Administrator') return true;
                return false;
            },
            groupOptions(){
                return this.groups.sort(function(a, b) {
                    var textA = a.RegionCode.toUpperCase();
                    var textB = b.RegionCode.toUpperCase();
                    return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
                });
            },
            roles(){
                let role = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);

                if (role === 'SmartSales Admin') {
                    return Object.entries(userRoleEnum).filter(([k,v]) => v >=  2); // can create Sales Administrators and Lesser Users
                } else if (role === 'Sales Administrator'){
                    return Object.entries(userRoleEnum).filter(([k,v]) => v >=  2); // can create Sales Administrators and Lesser Users
                } else if (role === 'Sales Manager') {
                    return Object.entries(userRoleEnum).filter(([k,v]) => v === 4); // can create Sales Reps
                }

            },
						usertypes(){
								return [
										['Not Set', 0],
										['Not Billed - Not Activate', 1],
										['Not Billed - Disabled', 2],
										['Not Billed - Exempt', 3],
										['Not Billed - Support', 4],
										['BILLED - Discounted Acct', 5],
										['BILLED - Rep Acct', 6],
										['BILLED - Manager Acct', 7],
										['BILLED - Admin Acct', 8],
								];
						},
            lockoutStatusClass(){
                return this.user.IsLockedOut ? 'text-danger' : 'text-success';
            },
            lockoutStatus(){
                return this.user.IsLockedOut ? 'DISABLED' : 'ENABLED' ;
            }
        },
        methods: {
						lockedOutChanged(isLockedOut) {
							this.user.UserType = isLockedOut ? 2 : 0;
						},
            removeGroupsSelected(){
                this.user.GroupIds = [];
            },
            onChargeableChange(field, value) {
                if (value === true) {
                    this.user[field] = true;
                    this.chargePendingField = field;
                    this.$refs.chargeModal.openModal();
                } else {
                    this.user[field] = false;
                }
            },
            onChargeDialogCancel() {
                this.user[this.chargePendingField] = false;
                this.chargePendingField = null;
                this.$refs.chargeModal.closeModal();
            },
            onChargeDialogAccept() {
                const field = this.chargePendingField;
                this.user[field] = true;
                if (field === 'CanAccessAllGroups') {
                    this.removeGroupsSelected();
                }
                this.chargePendingField = null;
                this.$refs.chargeModal.closeModal();
            },
            resendEmail(){
                UserService.resendActivationEmail(this.user.AppUserId)
                    .then(res => {
                        console.log('res', res)
                        this.$store.dispatch('ADD_NOTIFICATION', { text: `Activation email has been sent to ${this.user.Email}`, type: 'success'});
                    })
                    .catch(err => {
                        console.log('err', err)
                        this.$store.dispatch('ADD_NOTIFICATION', { text: `Activation email was not able to send to ${this.user.Email} at this time`, type: 'error'});
                    })
            },
            updateUser(){
                this.$v.user.$touch();
                if (this.$v.user.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                let user = this.handleManagerSetup(this.user);

                // let promises = [];
                // if (user.IsLockedOut){
                //     promises.push(UserService.lock(user.AppUserId))
                // } else {
                //     promises.push(UserService.unlock(user.AppUserId))
                // }

                // promises.push(UserService.update(user));

                // Promise.all(promises)
                UserService.update(user).then(res => {
                    console.log('res', res)
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'User Updated', type: 'success'});
                    this.$emit('update:success');
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                })
            },
            createUser(){
                this.$v.user.$touch();
                if (this.$v.user.$invalid){
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'See Validation Errors', type: 'error' });
                    return;
                }

                let user = this.handleManagerSetup(this.user);

                UserService.create(this.$route.params.id, user).then(res => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: 'User Created', type: 'success'});
                    this.$emit('update:success');
                }).catch(err => {
                    this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                })
            },
            handleManagerSetup(user){
                let currentUserRole = getKeyByValue(userRoleEnum,this.currentUser.UserRoleId);
                if (currentUserRole === 'Sales Manager'){
                    user.ManagerId = this.currentUser.SalesRepId;
                }
                if (user.ManagerId === 0){
                    user.ManagerId = null;
                }

                return user;
            },
            getUser(){
                const dealerId = this.$route.params.id;
                const userId = this.userId;
                if(!this.userId) return;
                DealerService.salesRep(dealerId, userId)
                    .then(res => {
                        //console.debug('USER: ', res);
                        this.user = res;
                        this.user.EmailToLowerCase = "";
                    })
                    .catch(err => {
                        this.$store.dispatch('ADD_NOTIFICATION', { text: err.response.data.Message, type: 'error'});
                    })
            }
        },
        validations: {
            user: {
                FirstName: {
                    required,
                },
                LastName: {
                    required,
                },
                EmailToLowerCase: {
                    required,
                    email,
                },
                Email: {
                    required,
                    email,
                }
            },
        },
        watch: {
            'user.UserRoleId': function (newRoleId,oldRoleId){
                if (newRoleId !== 4){
                    this.$nextTick(() => {
                        this.user.ManagerId = null;
                    })
                }
            }

        },
        created(){
            this.getUser();
        }
    }
</script>

<style scoped lang="scss">
    .edit-user {
        min-width: 900px;
        .group-select {
            background-color: $white;
						min-height: 50px;
        }
			.user-locked-state {
					min-width: 170px;
					margin-left: -180px;
					margin-top: 25px;
			}
			.user-locked-state-toggle {
					margin-top: 25px;
			}
		}
</style>
